function getRandomNum(max, min = 0) {
  return Math.floor(Math.random() * max) + min
}

export function getRandom(length) {
  const res = []
  let num
  function next() {
    const last = res[res.length - 1] || 0
    switch (last) {
      case 0:
        num = getRandomNum(3)
        if (num === 0 || num === 1) {
          res.push(1)
        } else {
          res.push(2)
        }
        break
      case 1:
        res.push(0)
        break
      case 2:
        res.push(0)
        break
      default:
        return 0
    }
  }
  for (let i = 0; i < length; i++) {
    if (i % 7 === 0) {
      res.push(0)
    } else {
      next()
    }
  }
  return res
}

export function knuthDurstenfeldShuffle(array) {
  var len = array.length
  for (var i = len - 1; i > 1; i--) {
    var j = Math.floor(Math.random() * (i + 1))
    var temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}
// const res = getRandom(7000000)
// const result = [0, 0, 0]
// for (let i = 0; i < res.length; i++) {
//   result[res[i]] = result[res[i]] + 1
// }
// console.log(result)
